export const topNavLinks = [
  {
    id: 'ee46t',
    name: 'Inicio',
    href: '/',
  },
  {
    id: 'eexcty',
    name: 'Grabado y corte Laser',
    href: '/productsLaser',
  },
  {
    id: 'eexcte',
    name: 'Impresión3d',
    href: '/products3d',
  },
  {
    id: 'eexct2',
    name: 'Mates y accesorios',
    href: '/productsMates',
  },
   {
    id: 'eexct3',
    name: 'Tablas de madera',
    href: '/productsBbq'
  },
  {
    id: 'h6ii8g',
    name: 'Contacto',
    href: '/contact',
  },
  {
    id: 'f678ty',
    name: 'Carrito',
    href: '/cart',
  },
];

export const NavLinks = [
  {
    id: 'ee46t',
    name: 'Inicio',
    href: '/',
  },
  {
    id: 'eexcj',
    name: 'Corte y grabado Laser',
    href: '/productsLaser',
  },
  {
    id: 'eexct',
    name: 'Impresión 3d',
    href: '/products3d',
  },
  {
    id: 'eexct1',
    name: 'Mates y accesorios',
    href: '/productsMates',
  },
  {
    id: 'eexct3',
    name: 'Tablas de madera',
    href: '/productsBbq'
  },
  {
    id: 'h6ii8g',
    name: 'Contacto',
    href: '/contact',
  },
  {
    id: 'f678ty',
    name: 'Carrito',
    href: '/cart',
  },
];


export const note =
  'Los precios están sujetos a cambios y pueden variar según el diseño, tamaño o disponibilidad de materiales. ' +
  'Para confirmar el precio actualizado, no dudes en enviarnos un mensaje por WhatsApp.'

export const instagramPhotos = [
  {
    img: `${process.env.PUBLIC_URL}/images/shots/laser1.webp`,
    content: "¡Descubrí tu próximo mate favorito! 🍃\n\nDesde nuestra sección 'Mates' encontrás todos los modelos disponibles."
  },
  {
    img: `${process.env.PUBLIC_URL}/images/shots/laser2.webp`,
    content: "Creamos esta caja de vino en fenólico para el emprendimiento Bacoria 🍷.\n\nCada caja puede ser totalmente personalizada para tu marca."
  },
  {
    img: `${process.env.PUBLIC_URL}/images/shots/laser3.webp`,
    content: "Mate imperial con virola grabada, diseñado especialmente para Bacoria 🍷.\n\nPersonalizalo para tu marca o regalo especial."
  },
  {
    img: `${process.env.PUBLIC_URL}/images/shots/laser4.webp`,
    content: "Llavero de cuero con grabado láser de un gaucho montando su caballo 🐎."
  },
  {
    img: `${process.env.PUBLIC_URL}/images/shots/laser7.webp`,
    content: "Llaveros de cuero con grabado láser de Messi\n\nDiseñados especialmente para un cliente."
  },
  {
    img: `${process.env.PUBLIC_URL}/images/shots/laser9.webp`,
    content: "Bastidores personalizados impresos en 3D para el taller 'Un hilo a la vez'.\n\nCada diseño puede adaptarse a tus necesidades."
  },
  {
    img: `${process.env.PUBLIC_URL}/images/shots/laser10.webp`,
    content: "Llavero de cuero con grabado láser de la cabeza de un caballo y su tira de sujeción."
  },
  {
    img: `${process.env.PUBLIC_URL}/images/shots/laser11.webp`,
    content: "Caja con separadores en fenólico\n\nDiseñada para organizar cosméticos como rímel, labiales y más."
  }
]